<script>
import { BListGroupItem } from "bootstrap-vue";

export default {
  extends: BListGroupItem
};
</script>